import phumVillage from "@/api/corporate/phum-village";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return phumVillage.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return phumVillage.store(data);
    },

    update(context, { id, data }) {
        return phumVillage.update(id, data);
    },

    destroy(context, id) {
        return phumVillage.destroy(id);
    },

    getCityProvince() {
        return phumVillage.cityProvince();
    },

    getKhanDistrict(context, data) {
        return phumVillage.khanDistrict(data);
    },

    getSangkatCommune(context, data) {
        return phumVillage.sangkatCommune(data);
    }
};
